/*
 * This component takes the place of a normal submit button placed inside a form, but which requires a loading state--
 *  in this case, a throbbing state.
 *
 * Simply use the `isThrobbing` prop to set the state of the component.
 *
 * NOTE: This button will trigger the `onSubmit` function for forms!
 * NOTE: You probably shouldn't add an `onClick` function to this component!
 */

import React from 'react'
import PropTypes from 'prop-types'

import Throbber from '../Throbber'

const ThrobbingSubmit = ({isThrobbing, value, ...rest}) => (
  <button type="submit" {...rest}>
    {isThrobbing ? <Throbber /> : value}
  </button>
)

ThrobbingSubmit.defaultProps = {
  value: 'Submit',
}

ThrobbingSubmit.propTypes = {
  isThrobbing: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default ThrobbingSubmit
